export default __webpack_public_path__ + "static/media/bird6.68cce2a1.svg";